import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useSelector } from 'react-redux';

import { FullScreenLoading } from '@backrs_ui/common-ui';

import { APP_ROUTE } from '@backrs_ui/grow-ui/src/App';
import { useAppDispatch, useAppSelector } from '@backrs_ui/grow-ui/src/redux/hooks';
import { RootState } from '@backrs_ui/grow-ui/src/redux/store';
import { markTourAsComplete, selectResultsPageTour } from '@backrs_ui/grow-ui/src/redux/tour/tour';
import { postCompletingTourBlueprint } from '@backrs_ui/grow-ui/src/redux/tour/tour.thunk';
import { selectUserSurveyResults } from '@backrs_ui/grow-ui/src/redux/userResponse/userResponse';

import { ResultPage } from './ResultPage';

export const MyResultsPageContainer = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const resultsPageTour = useAppSelector(selectResultsPageTour);

  const careerQuestions = useAppSelector((state: RootState) => state.survey.careerQuestions);
  const { careerCategories } = useAppSelector((state) => state.careerPath);

  const { mostRecentUserResponseSet, loadingMostRecentUserResponseSet } = useSelector(
    (state: RootState) => state.userResponseSet,
  );

  const user = useAppSelector((state: RootState) => state.user.user);
  const surveyResults = useSelector((state: RootState) => selectUserSurveyResults(state));

  const shouldUserBeRoutedToIntro =
    !mostRecentUserResponseSet &&
    !surveyResults &&
    !loadingMostRecentUserResponseSet &&
    !user?.access_token;

  useEffect(() => {
    if (shouldUserBeRoutedToIntro) {
      navigate(APP_ROUTE.INTRO);
    }
  }, [shouldUserBeRoutedToIntro, navigate]);

  function handleFinishingTour() {
    const resultsPageTourId = resultsPageTour?.id;

    if (!resultsPageTourId) {
      return;
    }

    if (user?.id) {
      // if there is a user id, we need to post to the API to mark the tour as complete
      dispatch(postCompletingTourBlueprint(resultsPageTourId));

      return;
    }

    // if there is no user id, just update the store to mark the tour as complete
    dispatch(markTourAsComplete(resultsPageTour.id));
  }

  const isLoadingResponseSet =
    !surveyResults ||
    !mostRecentUserResponseSet ||
    (loadingMostRecentUserResponseSet && user?.access_token);

  if (isLoadingResponseSet) {
    return <FullScreenLoading />;
  }

  return (
    <ResultPage
      tier={surveyResults.tier}
      entrepreneurshipRecommended={surveyResults.careerResults.entrepreneurship}
      userResponseSet={mostRecentUserResponseSet}
      careerPathSuggestions={surveyResults.careerPathSuggestions}
      careerPathCategories={careerCategories}
      careerQuestions={careerQuestions}
      firstName={user?.first_name}
      lastName={user?.last_name}
      createdAt={mostRecentUserResponseSet.created_at || new Date().toISOString()}
      user={user}
      resultsPageTour={resultsPageTour}
      onFinishOrSkipTour={handleFinishingTour}
    />
  );
};
